<template>
    <div>
        <div class="row no-gutters">
            <div class="col-md-3 pr-2">
                <div class="form-group">
                    <label class="font-weight-bold text-muted">{{ __('general.value') }}/{{ __('general.type') }}</label>
                    <div class="input-group">
                        <input class="form-control"
                               type="text"
                               :placeholder="__('general.value')"
                               v-model="pricing.value"
                        >
                        <select class="form-control" v-model="pricing.type">
                            <option value="percentage">%</option>
                            <option value="amount">€</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-4 pr-2">
                <div class="form-group">
                    <label class="font-weight-bold text-muted">{{ __('subscriptions.invoicing.period') }}</label>
                    <select class="form-control" v-model="pricing.invoicing_period">
                        <option v-for="period in periods" :value="period">
                            {{ __('subscriptions.invoicing.periods.' + period) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-4 pr-2">
                <div class="form-group">
                    <label class="font-weight-bold text-muted">{{ __('subscriptions.invoicing.type') }}</label>
                    <select class="form-control" v-model="pricing.invoicing_type">
                        <option v-for="type in types" :value="type">
                            {{ __('subscriptions.invoicing.types.' + type) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-1">
                <div class="form-group">
                    <label class="font-weight-bold">{{ __('general.actions') }}</label>
                    <button class="btn btn-light-danger">
                        <i class="fas fa-trash ml-1"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object
    },

    data() {
        return {
            pricing: {
                type: null,
                value: null,
                invoicing_period: null,
                invoicing_type: null,
            },
            periods: ['monthly', 'yearly', 'setup'],
            types: ['per_store', 'per_user', 'of_order_amount']
        }
    },

    beforeMount() {
        this.pricing = this.$inertia.form(this.value)
    },

    watch: {
        pricing: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
